import { render, staticRenderFns } from "./SpecialPriceDetails_Action.vue?vue&type=template&id=dd2ad14c&"
import script from "./SpecialPriceDetails_Action.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceDetails_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports